import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PdaService } from '../../services/pda.service';

@Component({
  selector: 'app-resource-summary',
  templateUrl: './resource-summary.component.html',
  styleUrls: ['./resource-summary.component.scss'],
})
export class ResourceSummaryComponent implements OnInit {
  materiales: any;
  servicios: any;
  costos: any;
  lang:string;
  @Output() public emitLoaded = new EventEmitter();
  @Input() planSelected: any;

  @Input() statisticsReload: any;
  total: string;
  constructor(private pda: PdaService, private translate: TranslateService,) {}

  ngOnInit(): void {
    this.lang=this.translate.currentLang=='es'?'es-ES':'en-US';
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.planSelected.length != 0) {
      this.getStats();
    }
    if(this.statisticsReload.length){
      this.getStats();
    }
      
    
  }
  getStats(){
    this.pda.getSummary(this.planSelected.id).subscribe(
      (res: any) => {
        this.emitLoaded.emit(true);
        this.materiales = res.data.accion.materiales;
        this.servicios = res.data.accion.Servicios;
        this.costos = res.data.accion.Costos;
        var map = {',':'.','.':','};
        this.costos.forEach(accion => {
          if(accion.costos=="NaN"){
          }
          accion.costos=parseFloat(accion.costos);
          accion.costos=accion.costos.toLocaleString(undefined,{ minimumFractionDigits: 2,
            maximumFractionDigits: 2});
          if(this.translate.currentLang=='es'){
            accion.costos=accion.costos.replace(/[,.]/g, function(k) {
              return map[k];
            });
          }
         
          if(accion.accion_hijo){
              accion.accion_hijo.forEach(accion2 => {
                accion2.costos = parseFloat(accion2.costos);
                accion2.costos = accion2.costos.toLocaleString(undefined,{ minimumFractionDigits: 2,
                maximumFractionDigits: 2});
                if(this.translate.currentLang=='es'){
                  accion2.costos=accion2.costos.replace(/[,.]/g, function(k) {
                    return map[k];
                  });
                }
                
                if(accion2.accion_hijo){
                    accion2.accion_hijo.forEach(accion3 => {
                    accion3.costos = parseFloat(accion3.costos);
                    accion3.costos = accion3.costos.toLocaleString(undefined,{ minimumFractionDigits: 2,
                    maximumFractionDigits: 2});
                    if(this.translate.currentLang=='es'){
                      accion3.costos=accion3.costos.replace(/[,.]/g, function(k) {
                        return map[k];
                      });
                    }
                    
                    if(accion3.accion_hijo){
                      accion3.accion_hijo.forEach(accion4 => {
                        accion4.costos = parseFloat(accion4.costos);
                        accion4.costos = accion4.costos.toLocaleString(undefined,{ minimumFractionDigits: 2,
                        maximumFractionDigits: 2});
                        if(this.translate.currentLang=='es'){
                          accion4.costos=accion4.costos.replace(/[,.]/g, function(k) {
                            return map[k];
                          });
                        }
                       
                      });
                    }
                  });
                }
              });
            }
        });
        this.total = res.data.accion.total_costo.toLocaleString(undefined,{ minimumFractionDigits: 2,
          maximumFractionDigits: 2});
          if(this.translate.currentLang=='es'){
            this.total=this.total.replace(/[,.]/g, function(k) {
              return map[k];
            });
          }
        
        
      },
      (err) => {
        console.log('error al obtener resumen', err);
      }
    );
  }
}
